import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import * as CONSTANTS from './constants.js'
import util from '@/util'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    contentLoaded: false,
    viewType: CONSTANTS.DEFAULT_VIEW_TYPE,
    views: [],
    categories: [],
    applications: [],
    alerts: [],
    errorMessages: [],
    user: {},
    previousRoute: {},
    previousAllTablePage: 1,
    previousAllTablePerPage: 50,
    previousAllTableSortOpts: {
      enabled: true,
      initialSortBy: { field: "title", type: "asc" }
    },
    previousDownloadTableSortOpts: {
      enabled: true,
      initialSortBy: { field: "title", type: "asc" }
    },
    hasFavorites: false
  },
  mutations: {
    setViewType (state, viewType) {
      state.viewType = viewType
    },
    setHasFavorites (state, hasFavorites) {
      state.hasFavorites = hasFavorites
    },
    setViews (state, views) {
      state.views = views
    },
    setCategories (state, categories) {
      state.categories = categories
    },
    setAPSToken(state, token) {
      state.token = token
    },
    setApplications (state, applications) {
      applications.forEach(a=>{
        a.downloadData = {
          isDownloading: false,
          stateText: "",
          progress: 0,
          downloadReady: false,
          request: ""
        }
      })
      state.applications = applications
    },
    setOfferings (state, offerings) {
      state.offerings = offerings
    },
    setContentLoaded (state, contentLoaded) {
      state.contentLoaded = contentLoaded
    },
    setAlerts (state, alerts) {
      state.alerts = alerts
    },
    setErrorMessages (state, errorMessages) {
      state.errorMessages = errorMessages
    },
    setUser (state, user) {
      state.user = user
    },
    setPreviousRoute (state, previousRoute) {
      state.previousRoute = previousRoute
    },
    setPreviousAllTablePage (state, previousAllTablePage) {
      state.previousAllTablePage = previousAllTablePage
    },
    setPreviousAllTablePerPage (state, previousAllTablePerPage) {
      state.previousAllTablePerPage = previousAllTablePerPage
    },
    setPreviousAllTableSortOpts (state, previousAllTableSortOpts) {
      state.previousAllTableSortOpts = previousAllTableSortOpts
    },
    setPreviousDownloadTableSortOpts (state, previousDownloadTableSortOpts) {
      state.previousDownloadTableSortOpts = previousDownloadTableSortOpts
    }
    
  },
  getters: {
    getViewType (state) {
      return state.viewType
    },
    getHasFavorites (state) {
      return state.hasFavorites
    },
    getViews (state) {
      return state.views
    },
    getCategories (state) {
      return state.categories
    },
    getApplications (state) {
      return state.applications
    },
    getOfferings (state) {
      return state.offerings
    },
    getAPSToken (state) {
      return state.token
    },
    getContentLoaded (state) {
      return state.contentLoaded
    },
    getAlerts (state) {
      return state.alerts
    },
    getViewById: (state) => (id) => {
      return state.views.find(view => view.id === id)
    },
    getCategoryById: (state) => (id) => {
      if (!state.categories) { return }
      return state.categories.find(category => category.id === id)
    },
    getApplicationById: (state) => (id) => {
      if (!state.applications) { return }
      return state.applications.find(app => app.id === id)
    },
    getErrorMessages(state) {
      return state.errorMessages
    },
    getUser(state) {
      return state.user
    },
    getPreviousRoute(state) {
      return state.previousRoute
    },
    getPreviousAllTablePage(state) {
      return state.previousAllTablePage
    },
    getPreviousAllTablePerPage(state) {
      return state.previousAllTablePerPage
    },
    getPreviousAllTableSortOpts(state) {
      return state.previousAllTableSortOpts
    },
    getPreviousDownloadTableSortOpts(state) {
      return state.previousDownloadTableSortOpts
    }
    
  },
  actions: {

    initialize ({ commit, dispatch, getters }) {

      //get error messages - we never use this. removed.
      // api.getErrorMessages({commit })
      // .then((resp)=>{
      //   commit('setErrorMessages', resp.data.data)
      // }).catch(error => {
      //   console.error('Error loading error messages', error)
      //   dispatch('addAlert', util.createAlert(null, CONSTANTS.ERROR_MSGS.GENERIC_ERROR, CONSTANTS.ALERT_CONTEXT.DANGER))
      // })

      let storeRef = this
      //make asynchronous api calls for views,categories,applications
      axios.all([api.getViews(), api.getCategories(), api.getApplications(), api.getFavorites(), api.getOfferings()])
        .then(axios.spread(function (viewResp, catsResp, appsResp, favsResp, offeringsResp) {
          dispatch('handleResponseAlerts', viewResp)
          dispatch('handleResponseAlerts', catsResp)
          dispatch('handleResponseAlerts', appsResp)
          let favorites = favsResp.data.data
          var apps = appsResp.data.data
          let hasFavorites = false
          for (let app of apps) {
            let favApp = favorites.find( (fav) =>{
              return app.id == fav.appId
            })
            
            if (favApp) {
              app.isFavorite = true
              hasFavorites = true
            } else {
              app.isFavorite = false
            }
          }
          commit('setHasFavorites', hasFavorites)
          
          commit('setApplications', apps)
          var categories = catsResp.data.data
          commit('setCategories', categories)
          var views = viewResp.data.data
          views.sort(util.orderSortComparator)

          //map apps to category apps
          views.forEach(v=>{
            if (v.categories) {
              v.categories.forEach(c=>{
                let tmpApps = []
                c.apps.forEach(a=>{
                  if (a) {
                    let app = getters.getApplicationById(a.id)
                    tmpApps.push(app)
                  }
                })
                c.apps = tmpApps
              })
              v.categories.sort(util.orderSortComparator)
            }
          })
          commit('setViews', views)
          commit('setOfferings', offeringsResp.data.data)
          commit('setContentLoaded', true)
        })).catch(error => {
          console.error('Error loading content', error)
          // Redirect to Help Hub error page on failure to initialize
          location.href = process.env.VUE_APP_HELPHUB_URL+"/error"
          // dispatch('addAlert', util.createAlert(null, CONSTANTS.ERROR_MSGS.GENERIC_ERROR, CONSTANTS.ALERT_CONTEXT.DANGER))
          // commit('setContentLoaded', true)
        })
        
    },
    retrieveViewFromRoute ({ state }, routeName) {
      return state.views.find(e => util.formatRouteName(e.title) === routeName)
    },
    addAlert ({ state, commit }, alert) {
      var alerts = state.alerts
      // if identity alert is already active, default this alert to inactive
      var existingAlert = alerts.find((e) => {
        return e.active && e.msg == alert.msg && e.contextClass == alert.contextClass
      })
      if (existingAlert) {  
        alert.active = false;
      }
      alerts.push(alert)
      commit('setAlerts', alerts)
    },
    handleResponseAlerts({dispatch}, resp) {      
      if (resp.data.status_code != 0 &&
        (resp.data.status_code < 200 || resp.data.status_code >= 300)) {
        dispatch('addAlert', util.createAlert(String(resp.data.status_code)))
      }
    }
  }
})
